module.exports = __webpack_public_path__ + "img/1688692940615-image.jpg.2497eda4.webp";